export default "__VITE_ASSET__9ae33674__"